// Components==============
import React, { useContext } from 'react';
import { GlobalRootModalContext } from 'utilities/GlobalContext/GlobalRootModal';
// =========================

export function useRootModal() {
  const { setRootModal, rootModal } = useContext(GlobalRootModalContext);

  const closeModal = () => {
    setRootModal(null);
  };

  const setModal = (modal: React.ReactNode) => {
    setRootModal(modal);
  };

  return { setModal, closeModal, rootModal };
}
